export const checkIfExist = (state: any, item: any) => {
  return state.customerTagList?.findIndex((tag: any) => tag.cid === item);
};
export const checkSearchIfExist = (state: any, item: any) => {
  return state.serchCustomerList?.findIndex((tag: any) => tag.cid === item);
};

export const filterSearch = (object: any, text: any) => {
  const name = object?.customerTagName?.toLowerCase() ?? "";
  const input = text?.toLowerCase();
  if (name.includes(input)) return true;
  else return false;
};
